import ampLocale from '@amplify/amp-locale/dist/amp-locale'

import routesConstants from 'app/constants/routes.constants'
import { LANGUAGE } from 'app/constants/language.constants'
import { LOCALIZATION_DICTIONARY } from './locale-dictionary'

const params: Record<string, string> = {}

const spanishRoutes = [
  routesConstants.CAMINOS_READER,
  routesConstants.CAMINOS,
  routesConstants.CAMINOS_3_READER,
  routesConstants.CAMINOS_3,
  routesConstants.CAMINOS_3_CA_READER,
  routesConstants.CAMINOS_3_CA,
  routesConstants.SONIDOS,
]

export const setDisplayLanguage = (language: string) => {
  ampLocale.setLanguage(language)
}

const isSpanishRoute = (pathname: string) =>
  spanishRoutes.some((route) => pathname.includes(route))

export const setLanguageBasedOnURL = (pathname: string) => {
  setDisplayLanguage(isSpanishRoute(pathname) ? LANGUAGE.ES : LANGUAGE.EN)
}

export const initDictionary = () => {
  ampLocale.setDictionary(LOCALIZATION_DICTIONARY)
  setLanguageBasedOnURL(window.location.href)
}

export const setParam = (key: string, value: string) => {
  params[key] = value
}

export const translate = (
  textKey: string,
  param?: { key: string; value: string }
) => {
  if (param) {
    setParam(param.key, param.value)
  }
  return ampLocale.translate(textKey, params)
}
